import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  ViewChildren,
  AfterViewInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { InsightsService } from '../insights/insights.service';
import { MiniAppsService } from './miniapps.service';
import IconsJSON from './material-icons-list-json.json';
import { Router, ActivatedRoute } from '@angular/router';
import * as htmlToImage from 'html-to-image';
import { MatStepper } from '@angular/material/stepper';
import { find, pull } from 'lodash';
import { ImageCroppedEvent, LoadedImage,CropperPosition } from 'ngx-image-cropper';
import * as Croppie from 'croppie';
import { CroppieDirective } from 'angular-croppie-module';
import { StyleRenderer, lyl, WithStyles, ThemeRef, ThemeVariables } from '@alyle/ui';
import {
  ImgCropperConfig,
  ImgCropperEvent,
  LyImageCropper,
  ImgCropperErrorEvent,
  ImgCropperLoaderConfig,
  STYLES as CROPPER_STYLES
} from '@alyle/ui/image-cropper';
import { LySliderChange } from '@alyle/ui/slider';
import { Platform } from '@angular/cdk/platform';
import { color } from '@alyle/ui/color';

@Component({
  selector: 'app-miniapps',
  templateUrl: './miniapps.component.html',
  styleUrls: ['./miniapps.component.css']
})
export class MiniAppssComponent implements OnInit, AfterViewInit {
  @ViewChild('checkpreview') checkpreview;
  @ViewChild('horizantalstepper', { static: false })
  horizantalstepper: MatStepper;
  verifyDetailsFormGroup: FormGroup;
  phoneNumberVerification: FormGroup;
  emailVerification: FormGroup;
  additionalInfoFormGroup: FormGroup;
  configueMiniAppsFormGroup: FormGroup;
  miniappsDetailsFormGroup: FormGroup;
  isEditable: boolean = false;
  phoneNumberPattern = '((\\+91-?)|0)?[0-9]{10}';
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  phoneNumberVerified: boolean = false;
  emailVerified: boolean = false;
  selected = 'Select miniapps';
  file: any;
  loginUserDetails: any;
  numberOfButtons: Array<number> = [];
  profilePhotoTemplate: any;
  miniappsId: string;
  isImageUploaded: boolean = false;
  uploadedImageSrc: any = '';
  welcomeBanner: any;
  welcomeBannerName: any;
  stepNumber: number;
  miniappsDetails: any;
  savedPhoneNumber: any;
  completed1: boolean;
  completed2: boolean;
  completed3: boolean;
  iconSelected: Array<boolean> = [];
  duplicateMobileNumber: string;
  duplicateEmailId: string;
  showFirstImage:boolean=true;
  showSecondImage:boolean=false;
  isActive:any;
  emailregex: RegExp =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  tab:any = 'tab1';
  tags_error = "";
  cropImage = false;
  verificationType: string = 'phone';
  @ViewChild('tagInput') tagInputRef: ElementRef;
  tags: string[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    public _matDialog: MatDialog,
    private _snackBar: MatSnackBar,
    private miniappsService: MiniAppsService,
    private insightsService: InsightsService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}
  selectVerificationType(type: string) {
    this.verificationType = type;
    this.setupFormGroup();
  }

  ngOnInit() {
    this.loginUserDetails = JSON.parse(
      localStorage.getItem('loginUserDetails')
    );
    this.setupFormGroup();
    // this.verifyDetailsFormGroup = this._formBuilder.group({
    //   displayName: ['', Validators.required],
    //   miniappsType: ['', Validators.required],
    //   phoneNumber: [
    //     '',
    //     [
    //       Validators.required,
    //       Validators.pattern('^[0-9]*$'),
    //       Validators.minLength(10),
    //       Validators.maxLength(10),
    //     ],
    //   ],
    //   miniappsCategory: ['', Validators.required]
    // });
    // this.phoneNumberVerification = this._formBuilder.group({
    //   verified: ['', Validators.required],
    // });

    this.additionalInfoFormGroup = this._formBuilder.group({
      customer_support_email: ['', [Validators.required, Validators.pattern(this.emailregex)]],
      customer_support_phone: [
        '',
        [
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(10),
          Validators.maxLength(20),
        ],
      ],
      profileInformation: [''],
      permissions: [''],
      customer_support_url: ['',[Validators.pattern('https?://.+')]]
      // welcomeBanner: ['', [Validators.required]],
    });
    this.configueMiniAppsFormGroup = this._formBuilder.group({
      allow_user_media: [false],
      webhook_url: ['', [Validators.required]],
      persistentMenu: ['null'],
      buttons: this._formBuilder.array([]),
    });
    this.miniappsDetailsFormGroup = this._formBuilder.group({
      profilePhoto: ['', Validators.required],
      description: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(500)]],
      languages: ['', [Validators.required]]
    });
    if (this.activatedRoute.snapshot.params.id) {
      this.miniappsId = this.activatedRoute.snapshot.params.id;
      this.getMiniAppsDetails();
    }
    if (this.activatedRoute.snapshot.params.stepNumber) {
      this.stepNumber = parseInt(
        this.activatedRoute.snapshot.params.stepNumber
      );
    }
  }

  setupFormGroup() {
    if (this.verificationType === 'phone') {
      this.verifyDetailsFormGroup = this._formBuilder.group({
        displayName: ['', Validators.required],
        miniappsType: ['', Validators.required],
        phoneNumber: [
          '',
          [
            Validators.required,
            Validators.pattern('^[0-9]*$'),
            Validators.minLength(10),
            Validators.maxLength(10),
          ],
        ],
        miniappsCategory: ['', Validators.required]
      });
      this.phoneNumberVerification = this._formBuilder.group({
        verified: ['', Validators.required],
      });
    } else if (this.verificationType === 'email') {
      this.verifyDetailsFormGroup = this._formBuilder.group({
        displayName: ['', Validators.required],
        miniappsType: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern(this.emailregex)]],
        miniappsCategory: ['', Validators.required]
      });
      this.emailVerification = this._formBuilder.group({
        verified: ['', Validators.required],
      });
    }
  }
  
  getErrorCustomerEmail() {
    return this.additionalInfoFormGroup.get('customer_support_email').hasError('required')
      ? ' Customer Support Email Id is required'
      : this.additionalInfoFormGroup.get('customer_support_email').hasError('pattern')
      ? 'Please Enter Valid Email ID'
      : '';
  }

  getErrorForLink() {
    return this.additionalInfoFormGroup.get('customer_support_url').hasError('pattern') ? 'Please Enter Valid Url' : '';
  }

  getErrorDescription() {
    return this.miniappsDetailsFormGroup.get('description').hasError('required')
      ? 'Description must be at least 2 characters'
      : this.miniappsDetailsFormGroup.get('description').hasError('requirements')
      ? 'Description must be at least 2 characters'
      : '';
  }

  getMiniAppsDetails() {
    this.miniappsService.getMiniAppsConfigurationById(this.miniappsId).subscribe(
      (res) => {
        this.miniappsDetails = res.body;
        this.getMiniAppsDetailsByMerchantId();
        this.getMiniAppsLabels();
      },
      (error) => {}
    );
  }

  getMiniAppsLabels() {
    this.miniappsService.getLabelsWithMiniAppsId(this.miniappsId).subscribe(
      (res) => {
        this.tags = res.data;
      }
    )
  }

  updateMiniAppsLabels(){
    const updatedTags = {
      data : this.tags
    }
    this.miniappsService.updateLabelsWithMiniAppsId(this.miniappsId, updatedTags).subscribe(
      (res) => {},
      (error) => {
        if(error.error.message){
          this._snackBar.open(error.error.message, 'close', {
            duration : 4000,
            horizontalPosition : 'end',
            verticalPosition : 'top',
          })
        }
      }
    );
  }

  onKeyUp(event: KeyboardEvent): void {
    const inputValue: string =this.tagInputRef.nativeElement.value;
    let words = inputValue.split(/\s+/);
    this.tags_error="";
    if(words.length >= 3){
        this.tagInputRef.nativeElement.value= words[0]+' '+words[1]
        this.tags_error = "A tag can have only two words"
      }
    if(event.code === 'Backspace'){
      this.tags_error=""
    }
    if (event.code === 'Backspace' && !inputValue) {
      this.removeTag();
      return;
    } else {
      if (event.code === 'Enter'||event.code === 'NumpadEnter') {
        this.addTag(inputValue);
      }
    }
  }

  addTag(tag: string) {
    if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
      tag = tag.slice(0, -1);
    }
    if(this.tags.includes(tag)){
      this.tags_error = "Same tag cannot be entered twice"
    }
    if(this.tags.length>=20){
      this.tags_error = "Maximum of 20 tags are allowed"
    }
    if (tag.length > 0 && !find(this.tags, tag) && !this.tags.includes(tag) && this.tags.length < 20) {
      this.tags.push(tag);
    }
    this.tagInputRef.nativeElement.value = '';
  }

  removeTag(tag?: string): void {
    if (!!tag) {
      pull(this.tags, tag);
    } else {
      this.tags.splice(-1);
    }
  }

  focusTagInput(): void {
    if(this.tagInputRef) this.tagInputRef.nativeElement.focus();
  }

  getMiniAppsDetailsByMerchantId() {
    this.miniappsService
      .getMiniAppsDetailsByMerchantId(this.loginUserDetails.merchant_id)
      .subscribe(
        (res) => {
          let allPhoneNumbers = res.body.data;
          allPhoneNumbers.forEach((element) => {
            if (element.mini_app_id == this.miniappsId) {
              this.savedPhoneNumber = element.mobile;
            }
          });
          this.buildFormGroup();
        },
        (error) => {}
      );
  }

  oncheckPreview(){
    this._matDialog.open(this.checkpreview, {
      position: {
        'top' : '4%',
        'left' : '11%'
      }
    });
  }
  
  buildFormGroup() {
    this.phoneNumberVerified = true;
    this.emailVerified = true;
    if (this.stepNumber >= 1) {
      if(this.verificationType === 'phone'){
        this.verifyDetailsFormGroup.patchValue({
          displayName: this.miniappsDetails.name,
          miniappsType: this.miniappsDetails.type,
          phoneNumber: this.savedPhoneNumber.replace(/\D/g, '').slice(-10),
          miniappsCategory: this.miniappsDetails.category
        });
        this.phoneNumberVerification.patchValue({
          verified: true,
        });
  
        this.phoneNumberVerification.updateValueAndValidity();
        this.verifyDetailsFormGroup.updateValueAndValidity();
      }
      else if(this.verificationType === 'email'){
        this.verifyDetailsFormGroup.patchValue({
          displayName: this.miniappsDetails.name,
          miniappsType: this.miniappsDetails.type,
          email: this.miniappsDetails.email,
          miniappsCategory: this.miniappsDetails.category
        });
        this.emailVerification.patchValue({
          verified: true,
        });
  
        this.emailVerification.updateValueAndValidity();
        this.verifyDetailsFormGroup.updateValueAndValidity();
      }
      this.completed1 = true;
    }
    if (this.stepNumber >= 2) {
      this.isImageUploaded = true;
      this.uploadedImageSrc = this.miniappsDetails.photo;

      this.miniappsDetailsFormGroup.patchValue({
        profilePhoto: this.miniappsDetails.photo,
        description: this.miniappsDetails.description,
        languages: this.miniappsDetails.language_supported
      });
     
      this.miniappsDetailsFormGroup.updateValueAndValidity();
      this.completed2 = true;
      this.miniappsDetailsFormGroup.controls['description'].valueChanges.subscribe(value => {
        if(value){
          this.completed2 = true;
        }else{
          this.completed2 = false;
        }
        
      });
      // this.miniappsDetailsFormGroup.controls['miniappsType'].valueChanges.subscribe(value => {
      //   if(value){
      //     this.completed2 = true;
      //   }else{
      //     this.completed2 = false;
      //   }
        
      // });
    }
    if (this.stepNumber >= 3) {
      if (this.miniappsDetails.welcome_banner) {
        this.welcomeBannerName = 'Template -1';
        this.welcomeBanner = this.miniappsDetails.welcome_banner;
        // this.additionalInfoFormGroup.controls.welcomeBanner.patchValue(
        //   this.miniappsDetails.welcome_banner
        // );
      }

      this.additionalInfoFormGroup.patchValue({
        customer_support_email: this.miniappsDetails.customer_support_email,
        customer_support_phone: this.miniappsDetails.customer_support_phone,
        profileInformation: this.miniappsDetails.user_details,
        permissions: this.miniappsDetails.permissions_required
      });

      console.log(this.additionalInfoFormGroup);
      this.additionalInfoFormGroup.updateValueAndValidity();
      this.completed3 = true;
      // this.additionalInfoFormGroup.controls['welcomeBanner'].valueChanges.subscribe(value => {
      //   if(value){
      //     this.completed3 = true;
      //   }else{
      //     this.completed3 = false;
      //   }
        
      // });
      this.additionalInfoFormGroup.controls['customer_support_email'].valueChanges.subscribe(value => {
        if(value){
          this.completed2 = true;
        }else{
          this.completed2 = false;
        }
        
      });
    }
    
    this.horizantalstepper.linear = true;
  }

  onClick(check){
        if(check==1){
          this.tab = 'tab1';
        }else if(check==2){
          this.tab = 'tab2';
        }
  }

  ngAfterViewInit() {
    if (this.activatedRoute.snapshot.params.stepNumber) {
      this.horizantalstepper.linear = false;
      this.horizantalstepper.selectedIndex = parseInt(
        this.activatedRoute.snapshot.params.stepNumber
      );
    }
  }
  
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  verify() {
    if (this.verifyDetailsFormGroup.valid) {
      let formValues = this.verifyDetailsFormGroup.controls;
      let request = {
        mobile: '+91' + formValues.phoneNumber.value,
        configuration: {
          name: formValues.displayName.value,
          category: formValues.miniappsCategory.value,
          type: formValues.miniappsType.value,
        },
      };
      
      this.miniappsService.createMiniApps(request).subscribe(
        (response) => {
          this._snackBar.open(response.body.message, 'close', {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        },
        (error) => {
          if(error.error.text == "Created"){
            this.duplicateMobileNumber=undefined
            const dialogRef = this._matDialog.open(OtpDialog, {
              data: this.verifyDetailsFormGroup.value,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result.data) {
                this.miniappsId = result.data;
                this.phoneNumberVerified = true;
                this.phoneNumberVerification.controls.verified.patchValue('true');
                this.completed1 = true;
              }
            });
          }
          if (error.error.message) {
            this.verifyDetailsFormGroup.controls['phoneNumber'].setErrors({'duplicate': true});
            this.duplicateMobileNumber = error.error.message;
          }
            
        }
      );
    } else {
      this._snackBar.open('Please enter valid Details', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
    }
  }

  verifyEmail(){
    console.log(this.verifyDetailsFormGroup.valid)
    if (this.verifyDetailsFormGroup.valid) {
      
      let formValues = this.verifyDetailsFormGroup.controls;
      let request = {
        email: formValues.email.value,
        configuration: {
          name: formValues.displayName.value,
          category: formValues.miniappsCategory.value,
          type: formValues.miniappsType.value,
        },
      };
      console.log("reqBody",request);
      this.miniappsService.createMiniApps(request).subscribe(
        (response) => {
          this._snackBar.open(response.body.message, 'close', {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        },
        (error) => {
          if(error.error.text == "Created"){
            this.duplicateEmailId=undefined
            const dialogRef = this._matDialog.open(EmailOtpDialog, {
              data: this.verifyDetailsFormGroup.value,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result.data) {
                this.miniappsId = result.data;
                this.emailVerified = true;
                this.emailVerification.controls.verified.patchValue('true');
                this.completed1 = true;
              }
            });
          }
          if (error.error.message) {
            this.verifyDetailsFormGroup.controls['email'].setErrors({'duplicate': true});
            this.duplicateEmailId = error.error.message;
          }
            
        }
      );
    } else {
      this._snackBar.open('Please enter valid email Details', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
    }
  }

  fileUpload(event) {
    if (event.target.files && event.target.files.length) {
      this.file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => (this.uploadedImageSrc = reader.result);

      reader.readAsDataURL(this.file);
      this.miniappsDetailsFormGroup.controls.profilePhoto.patchValue(this.file);
      console.log(this.miniappsId)
      this.miniappsService.updateProfilePhoto(this.miniappsId, this.file).subscribe(
        (result) => {},
        (error) => {
          if (error.status === 200) {
            this.isImageUploaded = true;
          }
          if (error.error.message) {
            this._snackBar.open(error.error.message, 'close', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          }
        }
      );
    }
  }

  openGuidelinespopup() {
    this._matDialog.open(GuidelinesDialog);
  }

  selectTemplate() {
    const templateDialogRef = this._matDialog.open(TemplateDialog, {
      data: this.miniappsId,
    });
    templateDialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.welcomeBanner = result.data.image;
        this.welcomeBannerName = 'Template -' + result.data.imageName;
        // this.additionalInfoFormGroup.controls.welcomeBanner.patchValue(
        //   this.welcomeBannerName
        // );
      }
    });
  }
  selectTemplateFile(event: any){
    this.welcomeBanner = event.target.files[0];
    this.welcomeBannerName = event.target.files[0].name;
    this.cropImage=true;
    const templateDialogRef = this._matDialog.open(TemplateUpload, {
      data: { 
      ImageData: event}
    });
    templateDialogRef.afterClosed().subscribe((result)=>{
        if(result.data){
          this.welcomeBanner = result.data.image;
          // this.additionalInfoFormGroup.controls.welcomeBanner.patchValue(
          //   this.welcomeBannerName
          // );
        }
    });
    
  }
  // this function will trigger on selection of persistenct menu

  onPersistentMenuSelection(selectedValue?: string) {
    let formArray = this.configueMiniAppsFormGroup.controls.buttons as FormArray;
    if (selectedValue != 'null') {
      let buttonCount = parseInt(selectedValue) - formArray.controls.length;
      if (buttonCount > 0) {
        let formArray = this.configueMiniAppsFormGroup.controls.buttons as FormArray;
        this.numberOfButtons = [...Array(buttonCount).keys()];
        this.numberOfButtons.forEach((element, index) => {
          formArray.push(
            this._formBuilder.group({
              id: (formArray.value.length + 1).toString(),
              body: ['', Validators.required],
              icon: [''],
              reply: ['', Validators.required],
              //action_type:['reply'],
            })
          );
          this.iconSelected.push(false);
        });
      } else {
        let formArray = this.configueMiniAppsFormGroup.controls.buttons as FormArray;
        formArray.controls.splice(
          formArray.controls.length - Math.abs(buttonCount),
          Math.abs(buttonCount)
        );
        this.iconSelected.splice(
          formArray.controls.length - Math.abs(buttonCount),
          Math.abs(buttonCount)
        );
      }
    } else {
      this.configueMiniAppsFormGroup.controls.buttons = this._formBuilder.array([]);
      this.configueMiniAppsFormGroup.updateValueAndValidity();
    }
  }

  // deleteButton(index){
  //   let formArray = this.configueMiniAppsFormGroup.controls.buttons as FormArray;
  //   formArray.removeAt(index)
  // }

  openIconPopup(index) {
    const iconLibraryDialogRef = this._matDialog.open(Iconlibrarydialog,{
      maxWidth:"90%",
    });
    iconLibraryDialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        let formGroup =
          this.configueMiniAppsFormGroup.controls.buttons['controls'][index];
        formGroup.controls.icon.patchValue(result.data);
        this.iconSelected[index] = true;
      }
    });
  }

  deleteIcon(index) {
    let formGroup =
      this.configueMiniAppsFormGroup.controls.buttons['controls'][index];
    formGroup.controls.icon.patchValue('');
    this.iconSelected[index] = false;
  }

  onclickOfImage(event) {
    console.log(this.miniappsDetailsFormGroup);
    let fileName = event.target.value;
    this.isImageUploaded = true;  // have to remove after api deploy

    const img = '/assets/profile-icons/' + fileName + '.png';
    this.convertRelativeUriToFile(img, 'profileIcon', null, (file) => {
      this.miniappsDetailsFormGroup.controls.profilePhoto.patchValue(file);
      this.file = file;
      const reader = new FileReader();
      reader.onload = (e) => (this.uploadedImageSrc = reader.result);

      reader.readAsDataURL(this.file);
      this.miniappsService.updateProfilePhoto(this.miniappsId, file).subscribe(
        (result) => {},
        (error) => {
          if (error.status === 200) {
            this.isImageUploaded = true;
            // this._snackBar.open(
            //   'Profile Photo uploaded succcessfully',
            //   'close',
            //   {
            //     duration: 2000,
            //     horizontalPosition: 'end',
            //     verticalPosition: 'top',
            //   }
            // );
          }
          if (error.error.message) {
            this._snackBar.open(error.error.message, 'close', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          }
        }
      );
    });
  }

  async convertRelativeUriToFile(filePath, fileName, mimeType, cb) {
    mimeType =
      mimeType ||
      `image/${filePath.split('.')[filePath.split('.').length - 1]}`;
    const imageUrl = await fetch(filePath);
    const buffer = await imageUrl.arrayBuffer();
    cb(new File([buffer], fileName, { type: mimeType }));
  }

  updateWebHookURL() {
    let request = {
      launch_url: this.configueMiniAppsFormGroup.controls.webhook_url.value,
    };
    this.miniappsService.updateMiniAppsConfiguration(this.miniappsId, request).subscribe(
      (result) => {},
      (error) => {
        if (error.status === 200) {
          // this._snackBar.open('Webhook Url saved successfully', 'close', {
          //   duration:3000,
          //   horizontalPosition: this.horizontalPosition,
          //   verticalPosition: this.verticalPosition,
          // });
        }
      }
    );
  }

  saveMiniAppsDetails(stepName, from?: string) {
    let requestObject = {};
    if(stepName == 'verifyDetails'){
      requestObject = {
        name: this.verifyDetailsFormGroup.controls.displayName.value,
        category: this.verifyDetailsFormGroup.controls.miniappsCategory.value,
      };
    }
    else if (stepName == 'MiniAppsDetails') {
      requestObject = {
        description: this.miniappsDetailsFormGroup.controls.description.value,
        language_supported: this.miniappsDetailsFormGroup.controls.languages.value
      };
      this.updateMiniAppsLabels();
      this.completed2 = true;
    } else if (stepName == 'additionalInfo') {

      requestObject = {
        customer_support_email: this.additionalInfoFormGroup.controls
          .customer_support_email.value
          ? this.additionalInfoFormGroup.controls.customer_support_email.value
          : null,
        customer_support_phone: this.additionalInfoFormGroup.controls
          .customer_support_phone.value
          ? this.additionalInfoFormGroup.controls.customer_support_phone.value
          : null,
        customer_support_url: this.additionalInfoFormGroup.controls.customer_support_url.value ? this.additionalInfoFormGroup.controls.customer_support_url.value : null,
      };
      if(this.additionalInfoFormGroup.controls.profileInformation.value && this.additionalInfoFormGroup.controls.profileInformation.value.length > 0)
         requestObject['user_details'] = this.additionalInfoFormGroup.controls.profileInformation.value
      if(this.additionalInfoFormGroup.controls.permissions.value && this.additionalInfoFormGroup.controls.permissions.value.length > 0)
         requestObject['permissions_required'] = this.additionalInfoFormGroup.controls.permissions.value

      this.completed3 = true;
    } else if (stepName == 'configureMiniApps') {
      
      this.updateWebHookURL();
      if (from === 'saveandexit') {
        this.router.navigateByUrl('/miniappss');
      }
      if (stepName == 'configureMiniApps') {
        this.launchMiniApps();
      }
      return;

    }

    this.miniappsService.updateMiniAppsConfiguration(this.miniappsId, requestObject).subscribe(
      (response) => {},
      (error) => {
        if (error.status === 200) {
          // this._snackBar.open('Details saved successfully', 'close', {
          //   duration: 3000,
          //   horizontalPosition: this.horizontalPosition,
          //   verticalPosition: this.verticalPosition,
          // });
          if (from === 'saveandexit') {
            this.router.navigateByUrl('/miniappss');
          }
          if (stepName == 'configureMiniApps') {
            this.launchMiniApps();
          }
        }
        if (error.error.message) {
          this._snackBar.open(error.error.message, 'close', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        }
      }
    );
  }

  uploadWelcomeBanner() {
    if(this.welcomeBanner.type){
    this.miniappsService
      .updateWelcomeBanner(this.miniappsId, this.welcomeBanner)
      .subscribe(
        (res) => {},
        (error) => {
          if (error.status === 200) {
            // this._snackBar.open('Template uploaded succcessfully', 'close', {
            //   duration: 4000,
            //   horizontalPosition: 'end',
            //   verticalPosition: 'top',
            // });
          }
          if (error.error.message) {
            this._snackBar.open(error.error.message, 'close', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          }
        }
      );
    }
  }
  changeProfilePhoto() {
    (this.uploadedImageSrc = ''),
      this.miniappsDetailsFormGroup.controls.profilePhoto.patchValue('');
    this.isImageUploaded = false;
    this.file = '';
  }

  launchMiniApps() {
    if (this.miniappsId) {
      this.router.navigateByUrl('/miniapps/launch/' + this.miniappsId);
    }
  }

  onDelete() {
    (this.welcomeBanner = undefined), (this.welcomeBannerName = undefined);
  }
  clickInput(){
    document.getElementById('imageFileUpload').click();
  }
}

@Component({
  selector: 'email-otp-dialog',
  templateUrl: 'email-otp-dialog.html',
  styleUrls: ['./miniapps.component.css'],
})

export class EmailOtpDialog{
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;
  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: true,
    inputStyles:{'border': '1px solid #C3D2FC'},
    placeholder: '',
  };
  otp: number;
  timeLeft: number = 40;
  interval: any;
  otpNumber;
  InvalidMessage: any;
  showNotification: boolean = false;
  notificationMessage: string;
  invalidOtpNotification:boolean = false;
  country_code = 'IN';

  constructor(
    public dialogRef: MatDialogRef<OtpDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private miniappsService: MiniAppsService,
    private _snackBar: MatSnackBar
  ) {
    this.startTimer();
  }

  onOtpChange(otp) {
    if(otp == ""){
      this.config.inputStyles ={'border': '1px solid #C3D2FC'}
    }
    this.otp = otp;
  }
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft != 0) {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.timeLeft = 40;
        }
      } else {
        this.timeLeft = 0;
      }
    }, 1000);
  }

  resendOTP() {
    let request = {
      email: this.data.email,
      configuration: {
        name: this.data.displayName,
        category: this.data.miniappsCategory,
        type: this.data.miniappsType,
      },
    };
    this.miniappsService.createMiniApps(request).subscribe(
      (response) => {
        this.timeLeft = 40;
        this.startTimer();
        this._snackBar.open(response.body.message, 'close', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
      },
      (error) => {
        if (error.error.message) {
          this.showNotification = true;
          this.notificationMessage = error.error.message;
        }
        setTimeout(()=>{                         
          this.showNotification = false;
      }, 4000);
      }
    );
  }

  closePopup() {
    this.dialogRef.close({ event: 'close', data: undefined });
  }

  confirmOTP() {
    this.config.inputStyles ={'border': '1px solid #C3D2FC'}
    let request = {
      email: this.data.email,
      otp: this.otp,
      country_code: this.country_code,
    };
    this.miniappsService.verifyMiniApps(request).subscribe(
      (response) => {
        if (response.body.message) {
          this._snackBar.open(response.body.message, 'close', {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
          this.dialogRef.close({ event: 'close', data: undefined });
        } else if (response.body.mini_app_id) {
          this.dialogRef.close({ event: 'close', data: response.body.mini_app_id });
        }
      },(error)=>{
        if(error.error.message){
          console.log("error",error.error.message);
          this.invalidOtpNotification=true;
          this.config.inputStyles ={'border': '1px solid #EB5757'}
          this.InvalidMessage = error.error.message
        }
        setTimeout(()=>{                         
          this.invalidOtpNotification = false;
          
      }, 4000);
    });
  }
}

@Component({
  selector: 'otp-dialog',
  templateUrl: 'otp-dialog.html',
  styleUrls: ['./miniapps.component.css'],
})
export class OtpDialog {
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;
  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: true,
    inputStyles:{'border': '1px solid #C3D2FC'},
    placeholder: '',
  };
  otp: number;
  timeLeft: number = 40;
  interval: any;
  otpNumber;
  InvalidMessage: any;
  showNotification: boolean = false;
  notificationMessage: string;
  invalidOtpNotification:boolean = false;

  constructor(
    public dialogRef: MatDialogRef<OtpDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private miniappsService: MiniAppsService,
    private _snackBar: MatSnackBar
  ) {
    this.startTimer();
  }

  onOtpChange(otp) {
    if(otp == ""){
      this.config.inputStyles ={'border': '1px solid #C3D2FC'}
    }
    this.otp = otp;
  }
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft != 0) {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.timeLeft = 40;
        }
      } else {
        this.timeLeft = 0;
      }
    }, 1000);
  }

  resendOTP() {
    let request = {
      mobile: '+91' + this.data.phoneNumber,
      configuration: {
        name: this.data.displayName,
        category: this.data.miniappsCategory,
        type: this.data.miniappsType,
      },
    };
    this.miniappsService.createMiniApps(request).subscribe(
      (response) => {
        this.timeLeft = 40;
        this.startTimer();
        this._snackBar.open(response.body.message, 'close', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
      },
      (error) => {
        if (error.error.message) {
          this.showNotification = true;
          this.notificationMessage = error.error.message;
        }
        setTimeout(()=>{                         
          this.showNotification = false;
      }, 4000);
      }
    );
  }

  closePopup() {
    this.dialogRef.close({ event: 'close', data: undefined });
  }

  confirmOTP() {
    this.config.inputStyles ={'border': '1px solid #C3D2FC'}
    let request = {
      mobile: '+91' + this.data.phoneNumber,
      otp: this.otp,
    };
    this.miniappsService.verifyMiniApps(request).subscribe(
      (response) => {
        if (response.body.message) {
          this._snackBar.open(response.body.message, 'close', {
            duration: 3000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
          this.dialogRef.close({ event: 'close', data: undefined });
        } else if (response.body.mini_app_id) {
          // this._snackBar.open('MiniApps created successfully', 'close', {
          //   duration: 3000,
          //   horizontalPosition: 'end',
          //   verticalPosition: 'top',
          // });
          this.dialogRef.close({ event: 'close', data: response.body.mini_app_id });
        }
      },(error)=>{
        if(error.error.message){
          this.invalidOtpNotification=true;
          this.config.inputStyles ={'border': '1px solid #EB5757'}
          this.InvalidMessage = error.error.message
        }
        setTimeout(()=>{                         
          this.invalidOtpNotification = false;
          
      }, 4000);
    });
     
  
  }



}

@Component({
  selector: 'guidelines-dialog',
  templateUrl: 'guidelines-dialog.html',
  styleUrls: ['./miniapps.component.css'],
})
export class GuidelinesDialog {
  constructor(public dialogRef: MatDialogRef<GuidelinesDialog>) {}

  closePopup() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'template-dialog',
  templateUrl: 'template-dialog.html',
  styleUrls: ['./miniapps.component.css'],
})
export class TemplateDialog {
  selectedTemplate: string;
  convertedImage: any;
  @Input() data: number;
  @Output() focusOut: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('template1') template1: ElementRef;
  @ViewChild('template2') template2: ElementRef;
  @ViewChild('template3') template3: ElementRef;
  currency = '$';
  editMode1 = false;
  editMode2 = false;
  editMode3 = false;
  data1 = 'Welcome to CG Storyland 😃';
  data2 = 'Watch your favourite stories at any time.';
  data3 = 'Welcome toCG Rhymes 😃';
  data4 =
    'Lorem ipsum dolor sit amet, consectetur.';
  data5 = 'Welcome to CG India Challenge 😃';
  data6 = 'How well do you know India? Explore India with these fun quizzes!';

  constructor(
    public templatedialogRef: MatDialogRef<TemplateDialog>,
    @Inject(MAT_DIALOG_DATA) public dailogData: any,
    private miniappsService: MiniAppsService,
    private _snackBar: MatSnackBar
  ) {}

  closePopup() {
    this.templatedialogRef.close();
  }

  onFocusOut() {
    this.focusOut.emit(this.data);
  }
  radioChange(){
    this.editMode1 = false;
    this.editMode2 = false;
    this.editMode3 = false;
    switch(this.selectedTemplate) {
      case '1':
        this.editMode1 = true;
        break;
      case '2':
        this.editMode2 = true;
        break;
      case '3':
        this.editMode3 = true;
        break;
      default:
        this.editMode1 = true;
    }
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  saveSelectedTemplate(n) {
    let id = 'template' + this.selectedTemplate
    let node_all= document.querySelectorAll("#"+id);
    let node : HTMLInputElement = <HTMLInputElement>node_all[n]
    setTimeout(()=>{         
    htmlToImage
      .toPng(node)
      .then((dataUrl) => {
        this.convertedImage = this.dataURItoBlob(dataUrl);
        this.convertedImage.lastModifiedDate = new Date();
        this.convertedImage.name = this.dailogData + 'template.png';
        this.templatedialogRef.close({
          event: 'close',
          data: {
            image: this.convertedImage,
            imageName: this.selectedTemplate,
          },
        });
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
    }, 500);
  }


}

@Component({
  selector: 'Icon-library-dialog',
  templateUrl: 'Icon-library-dialog.html',
  styleUrls: ['./miniapps.component.css'],
})
export class Iconlibrarydialog {
  iconFormGroup: FormGroup;
  iconsList: any;
  constructor(
    public IcondialogRef: MatDialogRef<Iconlibrarydialog>,
    private _formBuilder: FormBuilder
  ) {
    this.iconsList = IconsJSON;
    this.iconFormGroup = this._formBuilder.group({
      icon: ['', Validators.required],
    });
  }

  closePopup() {
    this.IcondialogRef.close({ event: 'close', data: undefined });
  }
  onclickOfIcon(event) { }
  saveIcon() {
    this.IcondialogRef.close({
      event: 'close',
      data: this.iconFormGroup.controls.icon.value,
    });
  }
}
const STYLES = (_theme: ThemeVariables, ref: ThemeRef) => {
  ref.renderStyleSheet(CROPPER_STYLES);
  return {
    cropper: lyl `{
      max-width: 400px
      height: 500px
      width: 300px
    }`,
    cropperResult: lyl `{
      position: relative
      width: 160px
      height: 250px
    }`,
    sliderContainer: lyl `{
      text-align: center
      max-width: 400px
      margin: 14px
    }`
  };
};
@Component({
  selector: 'template-upload',
  templateUrl: 'template-upload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./miniapps.component.css'],
  providers: [
    StyleRenderer
  ]
})
export class TemplateUpload implements WithStyles, AfterViewInit, OnInit{
 
  @Input() data: number;
  @Input() ImageData: any;
  @Output() focusOut: EventEmitter<number> = new EventEmitter<number>();
  templateUrl : any;
  classes = this.sRenderer.renderSheet(STYLES);
  croppedImage?: string | null = null;
  scale: number;
  ready = false;
  minScale: number;
  @ViewChild(LyImageCropper) readonly cropper!: LyImageCropper;
  myConfig: ImgCropperConfig = {
    width: 150, // Default `250`
    height: 200, // Default `200`
    fill: '#ff2997', // Default transparent if type == png else #000
    type: 'image/png', // Or you can also use `image/jpeg`
    responsiveArea: true
  };
  constructor(
    public templatedialogRef: MatDialogRef<TemplateUpload>,
    @Inject(MAT_DIALOG_DATA) public dailogData: any,
    private miniappsService: MiniAppsService,
    private _snackBar: MatSnackBar,
    readonly sRenderer: StyleRenderer,
    private _platform: Platform


  ) {}
  ngOnInit(): void {
    const reader = new FileReader();
    const imageFile = this.dailogData.ImageData.target.files[0];
		reader.readAsDataURL(imageFile);
    reader.addEventListener('load', ()=>{
      this.templateUrl = reader.result;
    })
  }

  closePopup() {
    this.templatedialogRef.close();
  }

  onFocusOut() {
    this.focusOut.emit(this.data);
  }
  ngAfterViewInit() {
    console.log(this.templateUrl);
    const reader = new FileReader();
    const imageFile = this.dailogData.ImageData.target.files[0];
		reader.readAsDataURL(imageFile);
    reader.addEventListener('load', ()=>{
      this.templateUrl = reader.result;
      if (this._platform.isBrowser) {
        const config: ImgCropperLoaderConfig = {
          scale: 0.745864772531767,
          xOrigin: 642.380608078103,
          yOrigin: 236.26357452128866,
          rotation: 0,
          originalDataURL: this.templateUrl  
        };
        this.cropper.loadImage(config);
      }
    })

  }
  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  onCropped(e: ImgCropperEvent) {
    this.croppedImage = e.dataURL;
    this.templatedialogRef.close({
      event: 'close',
      data: {
        image: this.dataURItoBlob(this.croppedImage),
      },
    });
  }
  onLoaded(e: ImgCropperEvent) {
  }
  onError(e: ImgCropperErrorEvent) {
    console.warn(`'${e.name}' is not a valid image`, e);
  }
  onSliderInput(event: LySliderChange) {
    this.scale = event.value as number;
  }


}